import type { RecruitingSiteResponse } from '@flex-apis/recruiting';
import type { AxiosInstance } from 'axios';
import type { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';

import { isErrorSubdomain, ReservedSubDomain } from '../../constants';

import { getRedirectInfoFromServerSidePropsContext } from './context';
import {
  ErrorPage,
  InternalServerError,
  NotFoundError,
  RedirectError,
  ServerSideError,
} from './errors';
import { fetchSubstituteSubdomain } from './fetch';

export function handleServerSideError(
  context: GetServerSidePropsContext,
  error: unknown
): GetServerSidePropsResult<any> {
  if (error instanceof ServerSideError) {
    return error.getServerSidePropsResult(context);
  }

  return new InternalServerError(
    '알 수 없는 에러가 발생했습니다.'
  ).getServerSidePropsResult(context);
}

export async function handleSystemSubdomain(param: {
  context: GetServerSidePropsContext;
  axiosInstance: AxiosInstance;
  subdomain: string;
}): Promise<void> {
  const { context, axiosInstance, subdomain } = param;

  if (isErrorSubdomain(subdomain)) {
    throw new ErrorPage('에러 도메인으로 접근했습니다.', subdomain);
  }

  if (subdomain === ReservedSubDomain.Redirect) {
    const [urlRootPath, path] =
      getRedirectInfoFromServerSidePropsContext(context);
    const targetSubdomain = await fetchSubstituteSubdomain(axiosInstance, {
      urlRootPath,
    });
    throw new RedirectError(
      'Redirect 도메인으로 접근했습니다.',
      targetSubdomain,
      path
    );
  }
}
